import React, { useEffect, useState } from "react";
import api from "../api";
import { FaTrash } from "react-icons/fa";
import NoticiaDetalle from "./NoticiaDetalle";
import { getImageUrl } from "../api"; // ✅ Centralizado

export default function PublicacionesList() {
  const [publicaciones, setPublicaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedNoticia, setSelectedNoticia] = useState(null);

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchPublicaciones = async () => {
      try {
        const resp = await api.get("/publicaciones");

        // ✅ Convertir URLs de imagen apenas llegan
        const publicacionesConImg = resp.data.data.map((pub) => ({
          ...pub,
          imagen_url: getImageUrl(pub.imagen_url),
        }));

        // Debug: mostrar las primeras URLs para verificar que se generen correctamente
        if (publicacionesConImg.length) {
          console.debug("[Publicaciones] sample imagen_url:", publicacionesConImg.slice(0,3).map(p => p.imagen_url));
        }

        setPublicaciones(publicacionesConImg);
      } catch (err) {
        console.error("❌ Error al cargar publicaciones:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPublicaciones();
  }, [token]);

  const puedeEliminar = () => {
    if (!user) return false;

    const rol = user.rol?.toLowerCase();
    const departamento = user.departamento?.toLowerCase();

    console.log("🔍 Verificando permisos de eliminación:");
    console.log("  - Rol:", user.rol);
    console.log("  - Departamento:", user.departamento);
    console.log("  - Departamento_id:", user.departamento_id);
    
    const puedeEliminarFlag = (
      rol === "administrador" ||
      departamento === "prensa"
    );

    console.log("  - ¿Puede eliminar?:", puedeEliminarFlag);
    
    return puedeEliminarFlag;
  };


  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar publicación?")) return;

    try {
      console.log(`🗑️ Intentando eliminar publicación con ID: ${id}`);
      await api.post(`/publicaciones/destroy`, { id });
      console.log(`✅ Publicación eliminada correctamente`);

      setPublicaciones((prev) =>
        prev.filter((p) => p.id_publicacion !== id)
      );
    } catch (err) {
      console.error("❌ Error al eliminar:", err);
      console.error("URL intentada:", err.config?.url);
      console.error("Método:", err.config?.method);
      console.error("Status:", err.response?.status);
      console.error("Response data:", err.response?.data);
      alert("No tienes permisos o ocurrió un error.");
    }
  };

  if (loading) return <p className="text-gray-500">Cargando...</p>;
  if (publicaciones.length === 0)
    return <p className="text-gray-500">No hay publicaciones.</p>;

  console.log("user.rol:", user?.rol);
console.log("user.departamento:", user?.departamento);
console.log("puedeEliminar():", puedeEliminar());


  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {publicaciones.map((pub) => (
          <div
            key={pub.id_publicacion}
            className="relative bg-white shadow-md rounded-lg overflow-hidden cursor-pointer"
            onClick={() => setSelectedNoticia(pub)}
          >
{puedeEliminar() && (

  <div>
  <button
    onClick={(e) => {
      e.stopPropagation();
      handleDelete(pub.id_publicacion);
    }}
    className="absolute top-2 right-2 bg-red-600 hover:bg-red-700 text-white p-2 rounded-full shadow-md z-10"
  >
    <FaTrash />
  </button>
  </div>
)}



            {pub.imagen_url ? (
              <img
                src={pub.imagen_url}
                alt={pub.titulo}
                className="w-full h-48 object-cover"
                onError={(e) => {
                  e.target.src = '/LogoPiedecuestana.png';
                }}
              />
            ) : (
              <img
                src="/LogoPiedecuestana.png"
                alt="Logo Piedecuestana"
                className="w-full h-48 object-contain"
              />
            )}

            <div className="p-4">
              <h2 className="text-lg font-bold mb-1">{pub.titulo}</h2>
              <p className="text-gray-600 line-clamp-3">{pub.contenido}</p>
              <p className="text-xs text-gray-400 mt-2">
                Publicado: {new Date(pub.created_at).toLocaleDateString()}
              </p>
            </div>
          </div>
        ))}
      </div>

      {selectedNoticia && (
        <NoticiaDetalle
          noticia={selectedNoticia}
          onClose={() => setSelectedNoticia(null)}
        />
      )}
    </>
  );
}
